import { PropsWithChildren } from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export interface StackProps {
  className?: string;
  justifyContent?: CSSProperties['justifyContent'];
  alignItems?: CSSProperties['alignItems'];
  gap?: CSSProperties['gap'];
  padding?: CSSProperties['padding'];
  margin?: CSSProperties['margin'];
  alignSelf?: CSSProperties['alignSelf'];
  width?: CSSProperties['width'];
  maxWidth?: CSSProperties['maxWidth'];
  minWidth?: CSSProperties['minWidth'];
  height?: CSSProperties['height'];
  maxHeight?: CSSProperties['maxHeight'];
  minHeight?: CSSProperties['minHeight'];
}

const Stack: React.FunctionComponent<PropsWithChildren<StackProps>> = ({
  children,
  className,
  justifyContent,
  alignItems,
  gap,
  padding,
  margin,
  alignSelf,
  width,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        gap,
        justifyContent,
        alignItems,
        padding,
        margin,
        alignSelf,
        width,
        maxWidth,
        minWidth,
        height,
        maxHeight,
        minHeight
      }}
    >
      {children}
    </div>
  );
};

export default Stack;
